<template>
    <b-alert show :variant="variant" class="text-center">
        <h5 class="alert-heading">Эффективность восстановления</h5>
        <h6>{{ coeff }} %</h6>
        <h6 class="alert-heading">{{ msg }}</h6>
    </b-alert>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            data: {
                type: Object,
            }
        },
        computed: {
            coeff: function () {
                return (100 - Math.max(0, Math.min(this.data.out.odv, 100))).toFixed(0);
            },
            coeffRate: function () {
                return Math.max(0, Math.min(this.data.out.odv, 100));
            },
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: [
                    {
                        is: function (x) {
                            return x >= 88;
                        },
                        msg: 'Крайне неудовлетворительно',
                        variant: 'danger',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 72, 88);
                        },
                        msg: 'Неудовлетворительно',
                        variant: 'danger',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 56, 72);
                        },
                        msg: 'Удовлетворительно',
                        variant: 'primary',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 41, 56);
                        },
                        msg: 'Хорошо',
                        variant: 'warning',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 27, 41);
                        },
                        msg: 'Хорошо',
                        variant: 'warning',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 11, 27);
                        },
                        msg: 'Отлично',
                        variant: 'success',
                    },
                    {
                        is: function (x) {
                            return x < 11;
                        },
                        msg: 'Отлично',
                        variant: 'success',
                    },
                ]
            }
        },
        methods: {

            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeffRate);
                });
            }
        }
    }
</script>